import { DESIGN_STYLES } from "../../optics/components/drawers/settings/features/countdown/defaults";

const DEFAULT = {
  colorMute: false,
  linkText: "Read more",
  url: {},
  newTab: true,
  icon: {
    id: "man-lifting-weights",
    name: "Man Lifting Weights",
    short_names: ["man-lifting-weights"],
    colons: ":man-lifting-weights:",
    emoticons: [],
    unified: "1f3cb-fe0f-200d-2642-fe0f",
    skin: 1,
    native: "🏋️‍♂️",
  },
  timerType: "fixed-color",
};

export const handleCountdownMigration = (data) => {
  const parsed = JSON.parse(data.data);
  const ignoreMigration = Object.values(DESIGN_STYLES).includes(
    parsed.timerType
  );
  if (ignoreMigration) return parsed;

  const titleIsEnabled = parsed.timerLayout.find(
    (layout) => layout.value === "title"
  );

  const title = titleIsEnabled ? parsed.title : "";

  return {
    ...parsed,
    ...DEFAULT,
    title,
    colorFields: {
      Timer: {
        light: parsed.colorFields.Timer,
        dark: parsed.colorFields.Timer,
      },
    },
  };
};
